import {
  Box,
  LocationOnline,
  MarkerLocationIcon,
  NavList,
  Paragraph,
} from '@deckee/deck-hand';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { formatLatLon } from '../../../helpers/coordinate-helpers';
import { captureEvent } from '../../../../services/event-capture';
import { ROUTE_NEW_MARKER_SELECT_ENTITY_TYPE } from '../../../../services/route/route-names';
import { transitionToNextRoute } from '../../../../services/route/route-navigation';
import {
  moveMapToCurrentLocation,
  selectUnitsConfig,
} from '../../../../services/store/modules/app-controls';
import { selectCurrentLocation } from '../../../../services/store/modules/geo-service';
import SheetLayout, {
  SheetBody,
} from '../../../layouts/SheetLayout/SheetLayout';
import SafetyGearLocationCard from '../../Prepare/components/SafetyGearLocationCard';

const MyLocationPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { latitude, longitude } = useSelector(selectCurrentLocation) as {
    latitude: number;
    longitude: number;
  };
  const unitsConfig = useSelector(selectUnitsConfig);

  const coordinateSystem = unitsConfig?.coordinate;
  // TODO: there is a bug here with lat/lon = zero (edge case)
  // - also exist elsewhere >> prob. should be handled inside `formatLatLon`
  const formattedLatLon =
    latitude && longitude
      ? formatLatLon(coordinateSystem, latitude, longitude)
      : null;

  const handleAddMarkerAtMyLocation = () => {
    captureEvent({
      type: 'signal: add new marker',
      payload: {
        action: 'add marker to my location',
      },
      sendToAmplitude: true,
    });

    transitionToNextRoute(ROUTE_NEW_MARKER_SELECT_ENTITY_TYPE, {
      lat: latitude,
      lon: longitude,
    });
  };

  const handleGoToDeckeeSignal = () => {
    captureEvent({
      type: 'signal: Go to Deckee Signal page',
      payload: {},
      sendToAmplitude: true,
    });

    history.push('signal');
  };

  useEffect(() => {
    dispatch(moveMapToCurrentLocation());
  }, [dispatch]);

  return (
    <SheetLayout showMenuBar={false} heading="My location">
      <SheetBody>
        <Paragraph textAlign="center">{`${formattedLatLon}`}</Paragraph>
      </SheetBody>
      {/* TODO: Fighting styles from the margin on navlist.item. Fix */}
      <Box p="2" pb="0" overflow="auto">
        <NavList>
          <NavList.Item onClick={handleGoToDeckeeSignal}>
            <LocationOnline color="#FF5C39" />
            <Paragraph>Activate Deckee Signal</Paragraph>
          </NavList.Item>

          <NavList.Item onClick={handleAddMarkerAtMyLocation}>
            <MarkerLocationIcon color="#FF5C39" />
            <Paragraph>Add new marker</Paragraph>
          </NavList.Item>
          <SafetyGearLocationCard
            showLatLon={false}
            latitude={+latitude}
            longitude={+longitude}
            chevron={false}
            heading="Mandatory safety gear in your area"
            description=''
          />
        </NavList>
      </Box>
    </SheetLayout>
  );
};

export default MyLocationPage;
